import { render, staticRenderFns } from "./courseChoose.vue?vue&type=template&id=bed49814&"
import script from "./courseChoose.vue?vue&type=script&lang=js&"
export * from "./courseChoose.vue?vue&type=script&lang=js&"
import style0 from "./courseChoose.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports